import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  // Button,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// import { DateRangePicker } from 'rsuite';
// import { DateRange } from 'rsuite/esm/DateRangePicker';
// import dayjs from 'dayjs';
import { showErrorToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import { RootState } from '../../redux/rootState';
import { formatPriceWithCommas, getZoneTime, stripCustPrefix } from '../../utils/CommonFunctions';
import { getJobBidReport } from '../JobScheduling/UnscheduledJobs/addJob/redux/jobScheduleSlice';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { Cancel } from '../../media/images/Cancel';
// import { predefinedRanges } from '../../Common/SearchHeader/utils/DatePickerRange';
import { PrintIcon } from '../../assets/TableIcons';
import DataTable from '../../Common/DataTable';
import { JobBidReportTableData } from './utils/TypeDashboard';
import { setLoader } from '../../redux/loaderSlice';
import { months } from '../calender/utils/constant';
import { Entries } from '../../Common/ComponentSelectInput/types';
import {
  resetPagination,
  setSortColumn,
  setSortDirection,
} from '../taiReportingSystem/redux/sliceReportWorkspace';

interface IForecastReportModal {
  open: boolean;
  handleClose: () => void;
}

export default function ForecastReportModal({
  open, handleClose,
}: IForecastReportModal) {
  const Datatablestyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    // height: 'fit-content',
    bgcolor: 'background.paper',
    borderRadius: '6px',
    boxShadow: 24,
    p: '6px 24px 24px 24px',
    height: 'auto',
    minHeight: '450px',
    '@media (max-width: 768px)': {
      p: '6px 6px 15px',
      height: 'auto',
    },
  };

  const dispatch = useDispatch();
  // const [dateOpen, setDateOpen] = useState(false);
  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(String(today.getMonth() + 1));
  const [selectedYear, setSelectedYear] = useState(String(today.getFullYear()));
  // const [enabled, setEnabled] = useState(false);
  // const [dateRange, setDateRange] = useState<DateRange | null>(null);
  // const handleDateChange = (value: DateRange | null) => {
  //   setDateRange(value);
  //   setEnabled(true);
  // };
  const {
    sortColumn, sortDirection,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);

  const getData = () => {
    if (selectedMonth && selectedYear) {
      const daysInMonth = new Date(Number(selectedYear), Number(selectedMonth), 0).getDate();

      const FromDate = `01-${selectedMonth?.length > 1 ? selectedMonth : `0${selectedMonth}`}-${selectedYear}`;
      const ToDate = `${daysInMonth}-${selectedMonth?.length > 1 ? selectedMonth : `0${selectedMonth}`}-${selectedYear}`;
      const payload = {
        FromDate,
        ToDate,
        SortDirection: sortDirection,
        SortColumn: sortColumn,
      };
      dispatch(getJobBidReport(payload));
    }
  };

  useEffect(() => {
    getData();
  }, [selectedMonth, selectedYear, sortDirection, sortColumn]);

  const { jobBidReportData, isLoading } = useSelector((state: RootState) => state.jobScheduleReducer);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const receivedReports = useMemo(() => {
    // if (jobBidReportData) {
    //   setEnabled(false);
    // }
    const received = jobBidReportData?.map((item) => ({
      id: item?.JobId,
      jobId_Hyperlink: item?.JobId,
      bidId: item?.BidId,
      // scheduleInfoToolTip: item?.UnitIds,
      custId: stripCustPrefix(item?.CustId),
      customerName: item?.CustomerName,
      siteName: item?.SiteName,
      siteState: item?.SiteState,
      bidAmount: `$ ${formatPriceWithCommas(String(item?.BidAmount))}`,
      createdBy: item?.CreatedBy,
      createdDate: getZoneTime(item?.CreatedDate || ''),
    }));
    return received;
  }, [jobBidReportData]);

  const receivedColumns = [
    { key: 'jobId_Hyperlink', label: 'Job #' },
    { key: 'bidId', label: 'Bid #' },
    // { key: 'scheduleInfoToolTip', label: 'Schedule Info' },
    { key: 'custId', label: 'Customer Id' },
    { key: 'customerName', label: 'Customer' },
    { key: 'siteName', label: 'Job Site' },
    { key: 'siteState', label: 'Job Site State' },
    { key: 'bidAmount', label: 'Bid Amount' },
    { key: 'createdBy', label: 'Created By' },
    { key: 'createdDate', label: 'Created At' },
  ];

  const downloadExcel = () => {
    if (jobBidReportData?.length > 0) {
      const exportedData = jobBidReportData?.map((items) => ({
        JobId: items?.JobId,
        BidId: items?.BidId,
        // 'Schedule Info': items?.UnitIds?.join(', '),
        CustomerId: stripCustPrefix(items?.CustId),
        Customer: items?.CustomerName,
        Site: items?.SiteName,
        'Site State': items?.SiteState,
        'Bid Amount ($)': Number(items?.BidAmount),
        'Created By': items?.CreatedBy,
        'Created At': getZoneTime(items?.CreatedDate || ''),
      }));
      exportToExcelData(
        {
          data: exportedData?.length > 0 ? exportedData : [],
          removeSn: true,
        },
        'JOB/BID REPORT',
      );
    } else {
      showErrorToaster('No records to export');
    }
  };

  const bidAmountSum = useMemo(() => {
    if (jobBidReportData?.length > 0) {
      const total = jobBidReportData.reduce((sum, x) => sum + (Number(x.BidAmount) || 0), 0);
      return total;
    } return 0;
  }, [jobBidReportData]);

  const years: Entries[] = useMemo(() => {
    const arr = Array.from({ length: 2099 - 1999 }, (_, index) => index + 2000);

    return arr.map((ele) => ({
      Text: String(ele),
      Value: String(ele),
    }));
  }, []);

  const handleRedirect = (jobId: string) => {
    const url = `/jobs/${jobId}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => () => {
    dispatch(resetPagination());
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Job/Bid Report
          </div>
          <div className="cancel-icon" onClick={() => handleClose()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          <div className="forecastButtonContainer">
            {/* <div className="dateRangeFilterRangeDatePicker">
              <p className="analystModalLabel">Select Date Range</p>
              <DateRangePicker
                name="Range"
                open={dateOpen}
                onClick={() => setDateOpen(!dateOpen)}
                onOk={() => setDateOpen(false)}
                value={dateRange}
                onChange={handleDateChange}
                ranges={predefinedRanges}
                placeholder="Date Range"
                className="dateRangeFilterCustomDateRangeCalender"
                character=" - "
                showCleanButton
                format="MM-dd-yyyy"
                placement="bottomStart"
              />
            </div> */}
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <label style={{ fontSize: '14px', fontWeight: '500', marginRight: '5px' }}>
                Month
              </label>
              <Select
                size="small"
                value={String(selectedMonth)}
                style={{ width: '150px' }}
                onChange={(event: SelectChangeEvent<string | string>) => setSelectedMonth(event.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: '220px', // Adjust the max height value as needed
                      maxWidth: '220px',
                    },
                  },
                }}
              >
                {months.map((item: Entries) => (
                  <MenuItem className="menu-item-enter" value={item.Value} key={item.Value}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <label style={{ fontSize: '14px', fontWeight: '500', marginRight: '5px' }}>
                Year
              </label>
              <Select
                size="small"
                value={String(selectedYear)}
                style={{ width: '100px' }}
                onChange={(event: SelectChangeEvent<string | string>) => (setSelectedYear(event.target.value))}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: '220px', // Adjust the max height value as needed
                      maxWidth: '220px',
                    },
                  },
                }}
              >
                {years.map((item: Entries) => (
                  <MenuItem className="menu-item-enter" value={item.Value} key={item.Value}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {/* <Button
              className={enabled ? 'button_save_and_next' : 'button_cancel cursorNotAllowed'}
              sx={{ height: 36, marginTop: '20px' }}
              onClick={getData}
            >
              Get Report
            </Button> */}
          </div>
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px',
          }}
          >
            <div className="pointCursor" onClick={downloadExcel}>
              <PrintIcon />
            </div>
            {receivedReports?.length > 0 && (
              <div style={{ fontSize: '14px', fontWeight: '500' }}>
                Total Bid Amount: $
                {' '}
                {formatPriceWithCommas(String(bidAmountSum))}
              </div>
            )}
          </div>
        </div>
        <DataTable<JobBidReportTableData>
          data={receivedReports || []}
          columns={receivedColumns}
          handleData={() => {}}
          totalRecords={10}
          handleRedirect={handleRedirect}
          sortCol={sortColumn}
          setSortCol={(e) => { dispatch(setSortColumn(e)); }}
          sortDir={sortDirection}
          setSortDir={(e) => { dispatch(setSortDirection(e)); }}
        />
      </Box>
    </Modal>
  );
}
